import { ProductMin, Subscription, UhcDeepLinks } from '@src/types.ts'
import { openUrl } from '@utils'

const getTitle = (isUhcSubscription: boolean, hasUhcSubscriptions: boolean) => {
  if (isUhcSubscription) {
    return 'SUBSCRIPTION'
  }

  return hasUhcSubscriptions ? 'NUTRISENSE SUBSCRIPTION' : undefined
}

export const getProgramDetailsCommonProps = (
  subscription: Pick<Subscription, 'id'> & {
    primaryProduct: Pick<ProductMin, 'uhc'>
  },
  uhcDeepLinks: UhcDeepLinks,
  hasUhcSubscriptions: boolean,
  showTitle: boolean = true,
) => {
  const isUhcSubscription = subscription.primaryProduct.uhc

  const manageButtonLabel = isUhcSubscription ? 'Manage subscription' : undefined
  const onManageButtonPress = isUhcSubscription ? () => openUrl(uhcDeepLinks.storeUrl) : undefined

  return {
    title: showTitle ? getTitle(isUhcSubscription, hasUhcSubscriptions) : undefined,
    showBillingFields: !isUhcSubscription,
    manageButtonLabel,
    onManageButtonPress,
  }
}
